import ITheme from '../ITheme';

import commonTheme from '../common';

const theme: ITheme = {
  ...commonTheme,
};

export default theme;
